import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaPassport, 
  FaCheckCircle, 
  FaFileAlt, 
  FaCalendarAlt, 
  FaChartLine,
  FaArrowLeft,
  FaWhatsapp,
  FaShieldAlt,
  FaClock,
  FaUserGraduate,
  FaEuroSign,
  FaUniversity,
  FaGlobe,
  FaLanguage,
  FaMoneyBillWave,
  FaHome,
  FaHeart,
  FaStar,
  FaQuoteLeft,
  FaGraduationCap,
  FaHandshake,
  FaRocket,
  FaSearch,
  FaEnvelope,
  FaPhoneAlt,
  FaChevronRight,
  FaRegClock,
  FaUserCircle
} from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './AccompagnementVisa.css';

const AccompagnementVisa = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const steps = [
    {
      id: 1,
      title: "Évaluation du dossier",
      description: "Analyse approfondie de votre situation académique et personnelle pour déterminer la meilleure stratégie.",
      icon: <FaFileAlt />,
      details: "Nous étudions votre parcours, vos objectifs et vos contraintes",
      color: "#dc143c"
    },
    {
      id: 2,
      title: "Préparation des documents",
      description: "Assistance complète dans la constitution de votre dossier : lettres de motivation, CV, justificatifs.",
      icon: <FaCheckCircle />,
      details: "Vérification et optimisation de chaque document",
      color: "#2a5298"
    },
    {
      id: 3,
      title: "Simulation d'entretien",
      description: "Préparation intensive à l'entretien Campus France et consulaire avec mises en situation réelles.",
      icon: <FaCalendarAlt />,
      details: "Entretiens blancs et coaching personnalisé",
      color: "#1e3c72"
    },
    {
      id: 4,
      title: "Suivi jusqu'à l'obtention",
      description: "Suivi personnalisé de votre dossier avec relais auprès des autorités jusqu'au visa obtenu.",
      icon: <FaChartLine />,
      details: "Accompagnement jusqu'à la validation finale",
      color: "#dc143c"
    }
  ];

  const benefits = [
    { icon: <FaShieldAlt />, title: "Garantie de sérieux", description: "Accompagnement certifié par des experts" },
    { icon: <FaClock />, title: "Réactivité", description: "Réponse sous 24h garantie" },
    { icon: <FaUserGraduate />, title: "Expertise", description: "Spécialistes des visas étudiants" },
    { icon: <FaEuroSign />, title: "Tarifs transparents", description: "Sans frais cachés, devis gratuit" }
  ];

  const documents = [
    { name: "Passeport valide", required: true, desc: "Validité supérieure à 6 mois" },
    { name: "Attestation d'inscription universitaire", required: true, desc: "Ou preuve d'admission" },
    { name: "Justificatifs de ressources financières", required: true, desc: "Minimum 615€/mois" },
    { name: "Justificatif d'hébergement", required: true, desc: "Attestation d'hébergement ou bail" },
    { name: "CV académique détaillé", required: true, desc: "Format européen recommandé" },
    { name: "Lettres de recommandation", required: false, desc: "Atout considérable" }
  ];

  const successStories = [
    {
      name: "Marie K.",
      country: "Cameroun",
      program: "Master en Finance",
      quote: "Grâce à l'accompagnement, j'ai obtenu mon visa en 3 semaines ! Un grand merci à toute l'équipe.",
      rating: 5
    },
    {
      name: "Ahmed B.",
      country: "Maroc",
      program: "Licence en Informatique",
      quote: "La simulation d'entretien m'a vraiment préparé. J'étais confiant et bien préparé.",
      rating: 5
    },
    {
      name: "Sophie L.",
      country: "Côte d'Ivoire",
      program: "Doctorat en Biologie",
      quote: "Service impeccable, réactif et professionnel. Je recommande vivement !",
      rating: 5
    }
  ];

  const faqs = [
    {
      q: "Quel est le délai moyen pour obtenir un visa étudiant ?",
      a: "Le délai varie entre 15 jours et 2 mois selon votre pays d'origine et la période de l'année. Nous optimisons ce délai en préparant votre dossier en amont et en suivant rigoureusement chaque étape."
    },
    {
      q: "Que faire en cas de refus de visa ?",
      a: "Nous analysons en détail les raisons du refus, identifions les points faibles et préparons une nouvelle demande renforcée. Notre taux de réussite après refus est de 65% grâce à notre expertise."
    },
    {
      q: "Proposez-vous un accompagnement Campus France ?",
      a: "Oui, nous proposons un accompagnement complet de l'inscription Campus France à l'entretien, incluant la préparation du dossier, la rédaction du projet d'études et les simulations d'entretien."
    },
    {
      q: "Quels sont les justificatifs financiers requis ?",
      a: "Les justificatifs incluent : attestation bancaire, relevés de comptes, attestation de bourse, ou garantie d'hébergement. Nous vous aidons à constituer un dossier financier solide et irréprochable."
    },
    {
      q: "Proposez-vous des services de logement ?",
      a: "Oui, nous vous accompagnons dans la recherche de logement en France et vous aidons à obtenir les attestations d'hébergement nécessaires pour votre dossier de visa."
    },
    {
      q: "Quels sont vos tarifs ?",
      a: "Nos tarifs varient selon l'accompagnement choisi. Nous proposons des forfaits personnalisés à partir de 390€. Contactez-nous pour un devis gratuit sans engagement."
    }
  ];

  const countries = ["Cameroun", "Maroc", "Côte d'Ivoire", "Sénégal", "Algérie", "Tunisie", "Mali", "Guinée", "RDC", "Madagascar"];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="visa-service">
      <Header />
      
      {/* Hero Section with Animated Background */}
      <section className="visa-hero">
        <div className="visa-hero-bg">
          <div className="visa-hero-bg-gradient"></div>
          <div className="visa-hero-bg-particles"></div>
        </div>
        <div className="visa-hero-container">
          <div className="visa-hero-content">
            <div className="visa-badge">
              <FaStar /> Taux de réussite 74%
            </div>
            <h1>Accompagnement <span className="visa-gradient-text">Visa Étudiant</span></h1>
            <p>Maximisez vos chances d'obtenir votre visa avec un accompagnement personnalisé étape par étape. Plus de 500 étudiants accompagnés avec succès.</p>
            <div className="visa-hero-actions">
              <Link to="/contact" className="visa-btn-primary">
                <FaRocket /> Démarrer mon dossier
              </Link>
              <Link to="/contact" className="visa-btn-outline">
                <FaPhoneAlt /> Être rappelé
              </Link>
              <a href="https://wa.me/33695744027" className="visa-btn-whatsapp-hero">
                <FaWhatsapp /> Consultation gratuite
              </a>
            </div>
            <div className="visa-hero-stats">
              <div className="visa-stat-item">
                <strong>74%</strong>
                <span>de réussite</span>
              </div>
              <div className="visa-stat-divider"></div>
              <div className="visa-stat-item">
                <strong>15j</strong>
                <span>délai moyen</span>
              </div>
              <div className="visa-stat-divider"></div>
              <div className="visa-stat-item">
                <strong>98%</strong>
                <span>clients satisfaits</span>
              </div>
              <div className="visa-stat-divider"></div>
              <div className="visa-stat-item">
                <strong>500+</strong>
                <span>étudiants accompagnés</span>
              </div>
            </div>
          </div>
        </div>
        <div className="visa-hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* Countries Section */}
      <section className="visa-countries">
        <div className="visa-container">
          <div className="visa-section-header">
            <h2>Nous accompagnons les étudiants de</h2>
            <p>Une expertise spécifique pour chaque pays d'origine</p>
          </div>
          <div className="visa-countries-grid">
            {countries.map((country, index) => (
              <div key={index} className="visa-country-item">
                <FaGlobe />
                <span>{country}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section with Cards Grid */}
      <section className="visa-process">
        <div className="visa-container">
          <div className="visa-section-header">
            <h2>Notre méthodologie</h2>
            <p>Un processus structuré en 4 étapes pour garantir votre succès</p>
          </div>
          <div className="visa-steps-grid">
            {steps.map((step) => (
              <div key={step.id} className="visa-step-card">
                <div className="visa-step-number" style={{ background: step.color }}>{step.id}</div>
                <div className="visa-step-icon-wrapper" style={{ color: step.color }}>
                  {step.icon}
                </div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                <span className="visa-step-detail">{step.details}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="visa-benefits">
        <div className="visa-container">
          <div className="visa-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="visa-benefit-card">
                <div className="visa-benefit-icon-wrapper">
                  {benefit.icon}
                </div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section with Split Layout */}
      <section className="visa-documents">
        <div className="visa-container">
          <div className="visa-documents-grid">
            <div className="visa-documents-left">
              <div className="visa-documents-badge">Documents requis</div>
              <h2>Constituons ensemble <br/>un dossier <span className="visa-gradient-text">irréprochable</span></h2>
              <p>Nous vous aidons à préparer tous les documents nécessaires pour maximiser vos chances de succès.</p>
              <div className="visa-documents-list">
                {documents.map((doc, index) => (
                  <div key={index} className="visa-doc-item">
                    <FaCheckCircle className={doc.required ? 'visa-doc-check required' : 'visa-doc-check optional'} />
                    <div className="visa-doc-info">
                      <div className="visa-doc-name">{doc.name}</div>
                      <div className="visa-doc-desc">{doc.desc}</div>
                    </div>
                    {doc.required && <span className="visa-doc-badge">Obligatoire</span>}
                  </div>
                ))}
              </div>
            </div>
            <div className="visa-documents-right">
              <div className="visa-documents-cta-card">
                <FaHandshake className="visa-cta-icon" />
                <h3>Service personnalisé</h3>
                <p>Analyse de votre situation unique pour déterminer les documents spécifiques à votre profil.</p>
                <Link to="/contact" className="visa-link-gradient">
                  Bénéficier d'un audit gratuit <FaChevronRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories Section - Sans images */}
      <section className="visa-testimonials">
        <div className="visa-container">
          <div className="visa-section-header">
            <h2>Ils ont réussi <span className="visa-gradient-text">grâce à nous</span></h2>
            <p>Découvrez les témoignages de nos étudiants accompagnés avec succès</p>
          </div>
          <div className="visa-testimonials-grid">
            {successStories.map((story, index) => (
              <div key={index} className="visa-testimonial-card">
                <div className="visa-testimonial-header">
                  <div className="visa-testimonial-avatar">
                    <FaUserCircle />
                  </div>
                  <div className="visa-testimonial-rating">
                    {[...Array(story.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>
                <div className="visa-testimonial-quote-icon">
                  <FaQuoteLeft />
                </div>
                <p className="visa-testimonial-quote">"{story.quote}"</p>
                <div className="visa-testimonial-author">
                  <h4>{story.name}</h4>
                  <p>{story.country} • {story.program}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section with Accordion */}
      <section className="visa-faq">
        <div className="visa-container">
          <div className="visa-section-header">
            <h2>Questions <span className="visa-gradient-text">fréquentes</span></h2>
            <p>Tout ce que vous devez savoir avant de commencer</p>
          </div>
          <div className="visa-faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="visa-faq-item">
                <button className="visa-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <FaChevronRight className={`visa-faq-icon ${activeFaq === index ? 'rotated' : ''}`} />
                </button>
                <div className={`visa-faq-answer ${activeFaq === index ? 'active' : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services Section */}
      <section className="visa-additional">
        <div className="visa-container">
          <div className="visa-section-header">
            <h2>Services <span className="visa-gradient-text">complémentaires</span></h2>
            <p>Un accompagnement complet pour votre projet d'études</p>
          </div>
          <div className="visa-additional-grid">
            <div className="visa-additional-card">
              <FaUniversity />
              <h3>Universités partenaires</h3>
              <p>+50 universités françaises partenaires</p>
            </div>
            <div className="visa-additional-card">
              <FaLanguage />
              <h3>Services linguistiques</h3>
              <p>Préparation TEF/TCF DELF/DALF</p>
            </div>
            <div className="visa-additional-card">
              <FaMoneyBillWave />
              <h3>Aide financière</h3>
              <p>Conseils pour bourses et financements</p>
            </div>
            <div className="visa-additional-card">
              <FaHome />
              <h3>Logement étudiant</h3>
              <p>Recherche et garantie de logement</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="visa-cta">
        <div className="visa-container">
          <div className="visa-cta-wrapper">
            <div className="visa-cta-content">
              <h2>Prêt à concrétiser votre projet <br/>d'études en France ?</h2>
              <p>Premier conseil personnalisé offert. Profitez de notre expertise dès aujourd'hui.</p>
              <div className="visa-cta-buttons">
                <Link to="/contact" className="visa-btn-cta-primary">
                  <FaCalendarAlt /> Prendre rendez-vous
                </Link>
                <a href="https://wa.me/33695744027" className="visa-btn-cta-whatsapp">
                  <FaWhatsapp /> Contactez-nous sur WhatsApp
                </a>
              </div>
              <div className="visa-cta-note">
                <FaHeart /> Sans engagement, réponse garantie sous 24h
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AccompagnementVisa;